import { buildCreateApi } from '../createApi.js';
import { coreModule } from '../core/module.js';
import { reactHooksModule } from './module.js';
export { reactHooksModule } from './module.js';

const createApi = buildCreateApi(coreModule(), reactHooksModule());

export { createApi };
//# sourceMappingURL=index.js.map
